/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscreate2Inputs */

const en_downloadlinkscreate2 = /** @type {(inputs: Downloadlinkscreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create link`)
};

const de_downloadlinkscreate2 = /** @type {(inputs: Downloadlinkscreate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link erstellen`)
};

/**
* | output |
* | --- |
* | "Create link" |
*
* @param {Downloadlinkscreate2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscreate2 = /** @type {((inputs?: Downloadlinkscreate2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscreate2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscreate2(inputs)
	return de_downloadlinkscreate2(inputs)
});
export { downloadlinkscreate2 as "downloadLinksCreate" }